"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Onboarding = /*#__PURE__*/function () {
  function Onboarding(client) {
    (0, _classCallCheck2["default"])(this, Onboarding);
    this.client = client;
  }

  (0, _createClass2["default"])(Onboarding, [{
    key: "login",
    value: function login(data) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post('/login', data, args);
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.client.post('/logout');
    }
  }, {
    key: "signup",
    value: function signup(data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.post('/signup', data, args);
    }
  }, {
    key: "signupWithToken",
    value: function signupWithToken(data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.post('/signup-with-token', data, args);
    }
  }, {
    key: "checkEmail",
    value: function checkEmail(data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.post('/check-email', data, args);
    }
  }, {
    key: "getCompanies",
    value: function getCompanies(search) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      if (search) {
        return this.client.get("/companies?query=".concat(encodeURIComponent(search)), args);
      }

      return this.client.get('/companies', args);
    }
  }, {
    key: "verifyEmail",
    value: function verifyEmail(data) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return this.client.put('/verify-email', data, args);
    }
  }, {
    key: "verifyEmailResend",
    value: function verifyEmailResend(params, data) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      return this.client.post("/verify-email/resend".concat(params), data, args);
    }
  }, {
    key: "verificationStatus",
    value: function verificationStatus() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      return this.client.get('/verification-status', args);
    }
  }, {
    key: "forgotPassword",
    value: function forgotPassword(data) {
      var _this$client;

      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return (_this$client = this.client).post.apply(_this$client, ['/forgot-password', data].concat(args));
    }
  }, {
    key: "verifyForgotPasswordOtp",
    value: function verifyForgotPasswordOtp(data) {
      var _this$client2;

      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return (_this$client2 = this.client).post.apply(_this$client2, ['/forgot-password/verify-otp', data].concat(args));
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(data) {
      var _this$client3;

      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      return (_this$client3 = this.client).post.apply(_this$client3, ['/reset-password', data].concat(args));
    }
  }, {
    key: "setup2fa",
    value: function setup2fa(data) {
      var _this$client4;

      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return (_this$client4 = this.client).post.apply(_this$client4, ['/setup-2fa', data].concat(args));
    }
  }, {
    key: "login2fa",
    value: function login2fa(data) {
      var _this$client5;

      for (var _len13 = arguments.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
        args[_key13 - 1] = arguments[_key13];
      }

      return (_this$client5 = this.client).post.apply(_this$client5, ['/login-2fa', data].concat(args));
    }
  }, {
    key: "setup2faEmail",
    value: function setup2faEmail() {
      var _this$client6;

      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        args[_key14] = arguments[_key14];
      }

      return (_this$client6 = this.client).get.apply(_this$client6, ['/setup-email-2fa'].concat(args));
    }
  }, {
    key: "login2faEmail",
    value: function login2faEmail(data) {
      var _this$client7;

      for (var _len15 = arguments.length, args = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
        args[_key15 - 1] = arguments[_key15];
      }

      return (_this$client7 = this.client).post.apply(_this$client7, ['/login-email-2fa', data].concat(args));
    }
  }, {
    key: "getTwoFactorAuthData",
    value: function getTwoFactorAuthData() {
      var _this$client8;

      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }

      return (_this$client8 = this.client).get.apply(_this$client8, ['/two-factor-data'].concat(args));
    }
  }, {
    key: "get2FAInfo",
    value: function get2FAInfo(userId) {
      var _this$client9;

      for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        args[_key17 - 1] = arguments[_key17];
      }

      return (_this$client9 = this.client).get.apply(_this$client9, ["/two-factor-info?userId=".concat(userId)].concat(args));
    }
  }, {
    key: "addStaticUser",
    value: function addStaticUser(data) {
      for (var _len18 = arguments.length, args = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
        args[_key18 - 1] = arguments[_key18];
      }

      return this.client.post('/client', data, args);
    }
  }, {
    key: "getEntityInviteLinkDetails",
    value: function getEntityInviteLinkDetails(type, code) {
      var _this$client10;

      for (var _len19 = arguments.length, args = new Array(_len19 > 2 ? _len19 - 2 : 0), _key19 = 2; _key19 < _len19; _key19++) {
        args[_key19 - 2] = arguments[_key19];
      }

      return (_this$client10 = this.client).get.apply(_this$client10, ["/entity/".concat(type, "/code/").concat(code, "/invite-link")].concat(args));
    }
  }]);
  return Onboarding;
}();

exports["default"] = Onboarding;